import axios from 'axios';
import endsWith from 'lodash/endsWith';
import { getVariableForEnv } from 'utils/env';

const handleTrailingSlash = (config) => {
  if (!endsWith(config.url, '/')) {
    config.url += '/';
  }
  return config;
};

export const portalsAPI = axios.create({
  baseURL: getVariableForEnv({
    production: 'https://portal.hometap.com/api/v1/',
    stage: 'https://stage.portal.htap.co/api/v1/',
    dev: 'https://dev.portal.htap.co/api/v1/',
  }),
  headers: {
    'Content-Type': 'application/json',
  },
  xsrfCookieName: 'portalscsrftoken',
  xsrfHeaderName: 'X-CSRFTOKEN',
});
portalsAPI.interceptors.request.use(handleTrailingSlash);
